import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const UiSkelton = (props) => {
  return <Skeleton variant='text' {...props} />;
};

export default UiSkelton;
